<template>
  <Transition name="fade">
    <div v-if="show" class="loading-dots" :style="styleVars">
      <span v-for="i in 3" :key="i"></span>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  show?: boolean
  size?: number
  color?: string
  gap?: number
  lift?: number
  speed?: number
}>(), {
  show: true,
  size: 3,
  color: '#FFD700',
  gap: 3,
  lift: 6,
  speed: 1500
})

const styleVars = computed(() => ({
  '--dot-size': `${props.size}px`,
  '--dot-color': props.color,
  '--dot-gap': `${props.gap}px`,
  '--dot-lift': `${props.lift}px`,
  '--dot-speed': `${props.speed}ms`,
}))
</script>

<style scoped>
.loading-dots {
  display: inline-flex;
  align-items: flex-end;
  gap: var(--dot-gap);
}
.loading-dots span {
  width: var(--dot-size);
  height: var(--dot-size);
  border-radius: 50%;
  background: var(--dot-color);
  animation: dot-bounce var(--dot-speed) infinite;
}
.loading-dots span:nth-child(2) { animation-delay: calc(var(--dot-speed) / 6); }
.loading-dots span:nth-child(3) { animation-delay: calc(var(--dot-speed) / 3); }

@keyframes dot-bounce {
  0%, 20%, 100% { transform: translateY(0); }
  10%           { transform: translateY(calc(-1 * var(--dot-lift))); }
}

.fade-enter-active, .fade-leave-active { transition: opacity .3s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
